module.exports = __webpack_public_path__ + "static/media/pics4.80f613f5.jpg";